import layout from "@src/layout"
let pre = "qualification-"
export default {
    path: '/qualification',
    name: 'qualification',
    redirect: {
        name: `${pre}qualification`
    },
    component: layout,
    children: [{
        path: 'index',
        name: `${pre}index`,
        meta: {
            title: "资质查询",
            header: true,
            auth: true,
        },
        component: () =>
            import ("@view/qualification")
    }, {
        path: 'detail',
        name: `${pre}/detail`,
        meta: {
            title: '企业详情',
            header: true,
            auth: true
        },
        component: () => import('@view/qualification/detail'),
    }]
}